export default {
	paginationWrapper: {
		padding: '8px 0',
	},
};
